var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuggestedRoles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#959598",
    fillRule: "nonzero",
    d: "M13.125 8.25a4.876 4.876 0 1 1-.001 9.751 4.876 4.876 0 0 1 .001-9.751zm0 .75a4.126 4.126 0 1 0 .001 8.251A4.126 4.126 0 0 0 13.125 9zm0 1.5c.207 0 .375.168.375.375v1.875h1.875c.181 0 .332.129.367.3l.008.075a.375.375 0 0 1-.375.375H13.5v1.875a.375.375 0 0 1-.3.367l-.075.008a.375.375 0 0 1-.375-.375V13.5h-1.875a.375.375 0 0 1-.367-.3l-.008-.075c0-.207.168-.375.375-.375h1.875v-1.875c0-.181.129-.332.3-.367zM5.162 0c.426 0 .815.24 1.005.622l.712 1.42a.374.374 0 0 0 .335.208h7.411c.622 0 1.125.504 1.125 1.125v3a.375.375 0 1 1-.75 0v-3A.375.375 0 0 0 14.625 3H7.213c-.426 0-.815-.24-1.005-.622L5.496.958A.374.374 0 0 0 5.161.75H1.126a.375.375 0 0 0-.375.375v11.25c0 .207.168.375.375.375h5.25a.375.375 0 1 1 0 .75h-5.25A1.125 1.125 0 0 1 0 12.375V1.125C0 .504.504 0 1.125 0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuggestedRoles);
export default __webpack_public_path__ + "static/media/suggested-roles.4ccdee12.svg";
export { ForwardRef as ReactComponent };